/**
 * @desc 根据计划ID查询月计划概览下载
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/plan/month/queryPlanOverview/download',
    data,
  });
}

export function mock(data: defs.IdRequest): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/plan/month/queryPlanOverview/download',
    data,
  });
}
